import { Spinner } from "@chakra-ui/react";
import { FC } from "react";

/**
 * Анимированный элемент загрузки 
 * @returns 
 */
export const Loader: FC = () => {

    return (
        <Spinner
            color="gray.400"
            width="40px"
            height="40px"
            alignSelf="center"
            m="auto">
        </Spinner>
    )
}
